import { Brand } from 'models/Brand';
import { Partner } from 'models/Partner';

export const brandUrlMapping = {
  'onemembersclub.com': {
    brandKey: Brand.ONE,
    partnerKey: Partner.One,
  },
  'demo.onemembersclub.com': {
    brandKey: Brand.ONE,
    partnerKey: Partner.One,
  },
  'elcidathome.com': {
    brandKey: Brand.ElCidShopAtHome,
    partnerKey: Partner.ElCid,
  },
  'uexperiences.com': {
    brandKey: Brand.UVCExperiences,
    partnerKey: Partner.UVC,
  },
  'hotelsbycruise.com': {
    brandKey: Brand.HotelsByCruisecom,
    partnerKey: Partner.CCM,
  },
  'myclubvacay.com': {
    brandKey: Brand.ClubVacay,
    partnerKey: Partner.GrandPacificResorts,
  },
  'travel.guestbookings.com': {
    brandKey: Brand.TravelGuestBookings,
    partnerKey: Partner.GuestBookings,
  },
  'guestbookings.com': {
    brandKey: Brand.GuestBookings,
    partnerKey: Partner.GuestBookings,
  },
  'princess.redeemyourtravel.com': {
    brandKey: Brand.PrincessCUG,
    partnerKey: Partner.RedeemYourTravel,
  },
  'uk.princesspromotions.com': {
    brandKey: Brand.FutureCruisePackagesUk,
    partnerKey: Partner.PrincessPromotions,
  },
  'ca.princesspromotions.com': {
    brandKey: Brand.FutureCruisePackagesCanada,
    partnerKey: Partner.PrincessPromotions,
  },
  'princesspromotions.com': {
    brandKey: Brand.FutureCruisePackages,
    partnerKey: Partner.PrincessPromotions,
  },
  'membergetaways.net': {
    brandKey: Brand.MemberGetaways,
    partnerKey: Partner.RSI,
  },
  'employee.onemembersclub.com': {
    brandKey: Brand.EmployeeBenefits,
    partnerKey: Partner.One,
  },
  'explorebypb.com': {
    brandKey: Brand.ExploreByPuebloBonito,
    partnerKey: Partner.PuebloBonito,
  },
  'mx.explorebypb.com': {
    brandKey: Brand.ExploreByPuebloBonitoMexico,
    partnerKey: Partner.PuebloBonito,
  },
  'suppliertesting.onemembersclub.com': {
    brandKey: Brand.SupplierTesting,
    partnerKey: Partner.One,
  },
  'mx.uexperiences.com': {
    brandKey: Brand.UExperiencesMexico,
    partnerKey: Partner.UVC,
  },
  'ca.uexperiences.com': {
    brandKey: Brand.UExperiencesCanada,
    partnerKey: Partner.UVC,
  },
  'leisurerewards.com': {
    brandKey: Brand.LeisureRewards,
    partnerKey: Partner.LeisureRewards,
  },
  'aspirexbenefits.com': {
    brandKey: Brand.Aspirex,
    partnerKey: Partner.Vidanta,
  },
  'plus.cruise.com': {
    brandKey: Brand.CruiseComPlus,
    partnerKey: Partner.CCM,
  },
  'go.bookit.com': {
    brandKey: Brand.Bookit,
    partnerKey: Partner.Bookit,
  },
  'my.bookit.com': {
    brandKey: Brand.MyBookit,
    partnerKey: Partner.Bookit,
  },
  'clubtravelconcierge.com': {
    brandKey: Brand.HolidayInnClubVacations,
    partnerKey: Partner.HolidayInnClubVacations,
  },
  'cruise.afvclub.com': {
    brandKey: Brand.ArmedForcesVacationClub,
    partnerKey: Partner.TravelAndLeisure,
  },
  'rcicruise.leisurerewards.com': {
    brandKey: Brand.RCI,
    partnerKey: Partner.TravelAndLeisure,
  },
  'kclubtravel.com': {
    brandKey: Brand.KimptonClub,
    partnerKey: Partner.HolidayInnClubVacations,
  },
  'travel.air.shop': {
    brandKey: Brand.AirShop,
    partnerKey: Partner.Bookit,
  },
  //TODO: This URL may change once the final requirements are confirmed.
  'book.emeraldcruises.com ': {
    brandKey: Brand.Emerald,
    partnerKey: Partner.Scenic,
  },

  //This will be used as workaround or new brands, when friendly URL mapping is not complete
  //Just replace the brandKey and partnerKey with the desired values
  'sales-dev-azcpahh0h2c2b6gu.z03.azurefd.net': {
    brandKey: Brand.Emerald,
    partnerKey: Partner.Scenic,
  },

  'sales-uat-ccdxc5dfddbza2dy.z03.azurefd.net': {
    brandKey: Brand.Emerald,
    partnerKey: Partner.Scenic,
  },

  'sales-prod-cvhkazcpfthkhvbq.z03.azurefd.net': {
    brandKey: Brand.Emerald,
    partnerKey: Partner.Scenic,
  },

  // Disabled/archived
  // 'guestbookings.co.uk',
  // 'victra.redeemyourtravel.com',
  // 'medallionclassmarket.com',
  // 'sandiego.guestbookings.com',
  // 'basspro.redeemyourtravel.com',
  // 'capitalvacationsclub.net',
  // 'clubprincess.com',
  // 'amz.guestbookings.com',
  // 'vivri.guestbookings.com',
  // 'magicbreaks.online',
  // 'prestigate.net',
  // 'princesspartnerpoints.com',
};

export const getBrandAndPartnerKeys = () => {
  const hostname = window.location.hostname.replace('www.', '');
  const parts = hostname.split('.');
  let mappingDetails = null;

  if (parts[0] === 'dev' || parts[0] === 'uat') {
    // Remove only the environment prefix and keep the rest of the URL
    const brandUrl = parts.slice(1).join('.');
    mappingDetails = brandUrlMapping[brandUrl as keyof typeof brandUrlMapping];
  } else {
    mappingDetails = brandUrlMapping[hostname as keyof typeof brandUrlMapping];
  }
  return mappingDetails;
};
